<div class="titlebar">
  <h3>{{ "Template.JobsComponent.subHeader_jobs" | translate }}</h3>
</div>

<h5>{{ "Template.JobsComponent.subHeader_statusInfo" | translate }}</h5>
<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col">{{ "Template.JobsComponent.label_functionName" | translate }}</th>
      <th scope="col">{{ "Template.JobsComponent.label_status" | translate }}</th>
      <th scope="col">{{ "Template.JobsComponent.label_trigger" | translate }}</th>
      <th scope="col">{{ "Template.JobsComponent.label_lastStart" | translate }}</th>
      <th scope="col">{{ "Template.JobsComponent.label_lastStop" | translate }}</th>
      <th scope="col">{{ "Template.JobsComponent.label_duration" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (infoItem of functionsInfo; track infoItem) {
      <tr>
        <td>
          @if (infoItem.id) {
            <span>{{ infoItem.id }}</span>
          }
        </td>
        <td [class]="{ 'table-danger': infoItem.lastStart < warnDateLongRunning && infoItem.status == 'RUNNING' }">
          @if (infoItem.status) {
            <span>{{ infoItem.status }}</span>
          }
        </td>
        <td>
          @if (infoItem.viaTrigger) {
            <span>{{ infoItem.viaTrigger }}</span>
          }
        </td>
        <td [class]="{ 'table-danger': infoItem.lastStart <= warnDateNotRunning && infoItem.viaTrigger == 'TIMERTRIGGER' }">
          @if (infoItem.lastStart) {
            <span>
              {{ infoItem.lastStart | date : "d. MMMM yyyy, H:mm:ss" }}
            </span>
          }
          @if (!infoItem.lastStart) {
            <span> --- </span>
          }
        </td>
        <td>
          @if (infoItem.lastStop) {
            <span>
              {{ infoItem.lastStop | date : "d. MMMM yyyy, H:mm:ss" }}
            </span>
          }
          @if (!infoItem.lastStop) {
            <span> --- </span>
          }
        </td>
        <td>
          @if (infoItem.duration) {
            <span>
              {{ infoItem.duration | date : "H:mm:ss" : "UTC" }}
            </span>
          }
          @if (!infoItem.duration) {
            <span> --- </span>
          }
        </td>
      </tr>
    }
  </tbody>
</table>
